import { ListItem, Stack, Typography } from "@mui/material"
import { Repeat } from "lib/@components/repeat"
import { NavigationItem } from "routes/asset-register/navigation-item"

export function RegimeEntry({ item: { title, where, id } }) {
    return (
        <ListItem>
            <Stack>
                <Typography variant="body1" sx={{ fontWeight: "bold" }} gutterBottom>
                    {title}
                </Typography>

                <Repeat list={where} item={<NavigationItem regimeId={id} />} />
            </Stack>
        </ListItem>
    )
}
